import { Box, Button, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Step2 = ({ sra, setSra, setStep, storedUser }) => {
  const [btnLoading, setBtnLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    setSra({ ...sra, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};
    const data = sra || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    if (isEmpty(data.paymentTerms)) {
      newErrors.paymentTerms = "Payment Terms is required";
    } else if (data.paymentTerms.length > 1000) {
      newErrors.paymentTerms = "Payment Terms should be up to 1000 characters";
    }

    if (isEmpty(data.deliveryTerms)) {
      newErrors.deliveryTerms = "Delivery Terms is required";
    } else if (data.deliveryTerms.length > 1000) {
      newErrors.deliveryTerms =
        "Delivery Terms should be up to 1000 characters";
    }

    if (isEmpty(data.contract)) {
      newErrors.contract = "Contract Agreement Reference is required";
    } else if (data.contract.length > 1000) {
      newErrors.contract =
        "Contract Agreement Reference should be up to 1000 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = async () => {
    if (!validateForm()) return;
    setBtnLoading(true);
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/draft-customer-approval?draftSraId=${sra.draftCustomerId}`,
        {
          paymentTerms: sra.paymentTerms,
          deliveryTerms: sra.deliveryTerms,
          contract: sra.contract,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setStep((prev) => prev + 1);
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleBack = () => {
    navigate(`/dashboard/create-customer-approval/draft/${sra.draftCustomerId}`)
    setStep((prev) => prev - 1);
  };

  return (
    <div style={{ position: "relative" }}>
      {btnLoading && <div className="loading-div"></div>}
      <h2>New Customer Approval Form</h2>
      <div className="progress-container">
        <span className="blue-bar" style={{ width: "40%" }}></span>
      </div>
      <div className="dashboard-container">
        <Box>
          <Typography className="form-title">Justification</Typography>
          <label htmlFor="paymentTerms">
            Payment Terms <span style={{ color: "#FF0000" }}>*</span>
          </label>
          <textarea
            className={`${errors.paymentTerms && "input-error"}`}
            name="paymentTerms"
            id="paymentTerms"
            rows={4}
            value={sra && sra.paymentTerms}
            onChange={handleChange}
            maxLength={1000}
          ></textarea>
          {errors.paymentTerms && (
            <p className="error">{errors.paymentTerms}</p>
          )}
          <label htmlFor="deliveryTerms">
            Delivery Terms <span style={{ color: "#FF0000" }}>*</span>
          </label>
          <textarea
            className={`${errors.deliveryTerms && "input-error"}`}
            name="deliveryTerms"
            id="deliveryTerms"
            rows={4}
            value={sra && sra.deliveryTerms}
            onChange={handleChange}
            maxLength={1000}
          ></textarea>
          {errors.deliveryTerms && (
            <p className="error">{errors.deliveryTerms}</p>
          )}
          <label htmlFor="contract">
            Contract Agreement Reference{" "}
            <span style={{ color: "#FF0000" }}>*</span>
          </label>
          <textarea
            className={`${errors.contract && "input-error"}`}
            name="contract"
            id="contract"
            rows={4}
            value={sra && sra.contract}
            onChange={handleChange}
            maxLength={1000}
          ></textarea>
          {errors.contract && <p className="error">{errors.contract}</p>}
        </Box>
      </div>
      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
        <Button
          className="btn-contained"
          onClick={handleNext}
          disabled={btnLoading}
        >
          {btnLoading ? "Submitting..." : "Next"}
        </Button>
      </Box>
    </div>
  );
};

export default Step2;
